"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryNavContext = void 0;
var _react = require("react");
const PrimaryNavContext = exports.PrimaryNavContext = /*#__PURE__*/(0, _react.createContext)();